import { Address } from 'nftx.js';

/**
 * Given a string it returns the first (after 0x) and last 4 characters with an ellipsis in the middle
 * @param address string
 */
const ellipsis = (address: any, leadOnly = false) =>
  address?.length > 10
    ? [
        address.substring(0, 4),
        !leadOnly
          ? address.substring(address.length - 4, address.length)
          : null,
      ].join('…')
    : address;

export default ellipsis;
